import styled from 'styled-components/macro';

export const LookupContainer = styled.div`
  width: 100%;
`;
